import React from "react"
import DynamicSelector from "components/Molecules/DynamicSelector"
import useAuth from "hooks/useAuth"
import { VARIETY_GROUPS } from "graphql/selector.queries.gql"

export default function VarietyGroupSelector() {
  const {
    user: { currentDepartment },
  } = useAuth()
  return (
    <DynamicSelector
      label="Variety Group"
      path="varietyGroup"
      query={VARIETY_GROUPS}
      variables={{
        departmentId: currentDepartment && currentDepartment.id,
      }}
    />
  )
}
